import { render, staticRenderFns } from "./InfoV2.vue?vue&type=template&id=b2e16034&"
import script from "./InfoV2.vue?vue&type=script&lang=ts&"
export * from "./InfoV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports